import e from"@emotion/styled";import{setFontSizeList as i,setColor as l,setFontWeight as s}from"../../../utils/generateStyles.js";const n=e.div`
  label: list-item;
  list-style-position: inside;
  margin: 0px;
  padding-right: 0;
  ${t=>t.isLI&&{listStyleType:"none"}};
  list-style-type: ${t=>t.listStyleType};
  ${t=>i(t.fontSize)}
  ${t=>l(t.color,"color")}
  ${t=>s(t.fontWeight)}
`,o=e.div`
  display: inline-flex;
  align-items: center;
  & > span {
    display: inline-flex;
    align-items: center;
  }
`,p=e.span`
  margin-left: 8px;
`;export{p as ListItemIconWrapperStyled,n as ListItemStyled,o as ListItemWrapperStyled};
